<template>
    <div class="my-order movie-order" ref="ticketcontainer">
        <!-- 头部 -->
        <div class="header bg-color-red">
            <div class="picTxt acea-row row-between-wrapper">
                <div class="text">
                    <div class="name">订单信息</div>
                </div>
                <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
            </div>
        </div>
        <div class="nav acea-row row-around">
            <!-- 状态导航栏 -->
            <div class="item" v-for="(item, key) in orderStatusList" :key="key" :class="{ on: type == item.id }"
                @click="$router.replace(`/cakeOrder/${item.id}`)">
                <div>{{ item.status }}</div>
                <div class="num">{{ item.orderNum }}</div>
            </div>
        </div>
        <!-- 订单列表 -->
        <div class="list">
            <div class="item" v-for="(order, key) in orderList" :key="key">
                <div class="title acea-row row-between-wrapper">
                    <div class="acea-row row-middle">
                        订单号：{{ order.order_id || "" }}
                    </div>
                    <div class="font-color-red">{{ statusText(order) }}</div>
                </div>
                <!-- content -->
                <div class="movie-box pad30 acea-row content">
                    <div class="left-img">
                        <img v-lazy="order.image_path" />
                    </div>
                    <div class="page-flex-1">
                        <p class="page-margin-bottom01">{{order.product_name}}</p>
                        <p class="page-margin-bottom01">规格：{{ order.spec_name }}</p>
                        <p class="page-margin-bottom01">配送费：{{ order.ship_amount }}</p>
                        <p class="page-margin-bottom01">数量：{{ order.number }}</p>
                        <p class="page-margin-bottom01 acea-row row-between">
                            <span>￥ {{ order.price }}</span>
                            <!-- <span>{{order.ctripprice}}</span> -->
                        </p>
                    </div>
                </div>
                <div class="total">
                    共计：<span>￥{{order.total_amount }}</span>
                </div>
                <!-- button -->
                <div class="bottom acea-row row-right row-middle">
                    <div v-if="order.paid=='0'">
                        <div class="bnt bg-color-red" @click="paymentTap(order)">
                            立即付款
                        </div>
                    </div>
                    <div style="margin-left: 0.2rem">
                        <div class="bnt bg-color-red" @click="$router.push({ path: '/UncleCakeDetail/' + order.order_id })">
                            查看详情
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 无订单时展示 -->
        <div class="noCart" v-if="orderList.length === 0 && page > 1">
            <div class="pictrue">
                <img src="@assets/images/order_Lack.png" />
                <div class="order_lack">暂无订单信息</div>
            </div>
        </div>
        <Loading :loaded="loaded" :loading="loading"></Loading>
</div>
</template>

<script>
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import { CakeOrderList, getdgOrderStatus } from "@api/cake";

export default {
    name: "cakeOrder",
    components: {
        Loading,
        Payment
    },
    data: function () {
        return {
            orderStatusList: [ //状态导航栏
                {
                    status: "待付款",
                    orderNum: 0,
                    id: 2,
                    name: "unpaid_count"
                }, {
                    status: "已付款",
                    orderNum: 0,
                    id: 3,
                    name: "unshipped_count"
                }, {
                    status: "已发货",
                    orderNum: 0,
                    id: 4,
                    name: "received_count"
                },{
                    status: "售后/退款",
                    orderNum: 0,
                    id: 5,
                    name: "refund_count"
                }
            ],
            offlinePayStatus: 2,
            orderData: {}, //订单信息
            type: parseInt(this.$route.params.id) || 0,
            page: 1,
            limit: 20,
            loaded: false,
            loading: false,
            orderList: [
            ],
            pay: false,
            payType: ["yue", "weixin", 'zh'],
            from: isWeixin() ? "weixin" : "weixinh5",
            money: null
        };
    },
    computed: {
        ...mapGetters(["userInfo"])
    },
    watch: {
        $route(n) {
            if (n.name === "cakeOrder") {
                const type = parseInt(this.$route.params.id) || 0;
                if (this.type !== type) {
                    this.changeType(type);
                }
                // 获取订单信息
                this.getdgOrderStatusData();
            }
        }
    },
    mounted() {
        this.getdgOrderStatusData();
        this.getCakeOrderList();
        this.$scroll(this.$refs.ticketcontainer, () => {
            !this.loading && this.getCakeOrderList();
        });
    },
    methods: {
        statusText: function (order) {
            if (order.status == '2') {
                if (order._status && order._status._title) { //已付款
                    return order._status._title;
                } else {
                    if (order.refund_status == 0) {
                        return "未退款";
                    } else if (order.refund_status == 1) {
                        return "申请中";
                    } else if (order.refund_status == 2) {
                        return "已退款";
                    } else if (order.refund_status == 3) {
                        return "退款失败";
                    }
                }
            };
            if (order.status == '1') {
                if (order.yincang) {
                    return order._status._title;
                } else {
                    return '已过期';
                }
            }
        },
        getdgOrderStatusData() {
            getdgOrderStatus().then(res => {
                this.orderData = res && res.data;
                this.orderStatusList.forEach((item, key) => {
                    item.orderNum = res.data[`${item.name}`];
                });
            });
        },
        async getCakeOrderList() {
            if (this.loading || this.loaded) return;
            this.loading = true;
            const { page, limit, type } = this;
            await CakeOrderList({
                page,
                limit,
                type
            }).then(res => {
                res.data && res.data.forEach((item, key) => {
                    item.yincang = true;
                    let nowTime = new Date().getTime();
                    if (item.expire_time) {
                        item.expire_time = new Date(item.expire_time.replace(/-/g, '/')).getTime();
                        let differ = parseFloat(nowTime - item.expire_time) / 1000;
                        if (differ >= 0) {
                            item.yincang = false;
                        }
                    }
                    if (item._refund_ticket == 1) {
                        item._refund_ticket_text = "退票";
                    } else {
                        item._refund_ticket_text = "不可退";//(全损)
                    }
                });
                if (res.data.length !== 0) {
                    this.orderList = this.orderList.concat(res.data);
                    this.page++;
                }
                this.loaded = res.data.length < this.limit;
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
                console.log(err);
            });
        },
        reload() {
            this.changeType(this.type);
        },
        changeType(type) {
            this.type = type;
            this.orderList = [];
            this.page = 1;
            this.loaded = false;
            this.loading = false;
            this.getCakeOrderList();
        },
        paymentTap: function (order) { //立即付款
            let nowTime = new Date().getTime();
            let differ = parseFloat(nowTime - order.expire_time) / 1000;
            if (differ >= 0) {
                order.yincang = false;
                this.$dialog.error('已过期请重新下单');
                return;
            }
           
            this.$router.push(`/dgPaymentResult?v=1&order_no=${order.order_no}`);
        }
    }
}
</script>

<style scoped>
.noCart {
    margin-top: 0.17rem;
    padding-top: 0.1rem;
}

.noCart .pictrue {
    width: 4rem;
    height: 3rem;
    margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
    width: 100%;
    height: 100%;
}

.left-img {
    width: 2rem;
    margin-right: .1rem;
}

.left-img img {
    width: 100%;
    height: auto;
}

.content {
    padding-top: .2rem;
    padding-bottom: .2rem;
    border-bottom: .02rem solid #eee;
}

.refund {
    background: #ccc;
    margin-right: .1rem;
}

.my-order .nav {
    margin-top: 0rem !important;
}
.my-order .header {
    background: -webkit-gradient(linear,right top,left top,from(#ff0b46),to(#ffaf98))!important;
}

.my-order .header:after {
    background: linear-gradient(-90deg,#ff0b46,#ffaf98)!important; 
}
.total{
    width: 100%;
    text-align: right;
    padding-right: 0.3rem;
}
   .total span{
    color: #ff0b46;
    font-size: 0.3rem;
    font-weight: 600;
   } 
</style>